import store from '@/store'

// ----------------------中英文本地存储
const LANGUE_KEY = 'CZB_WEB_LANGUE'

/**
 * 从本地缓存中获取语言
 */
export const locGetLangue = (): 'ZH' | 'EN' => {
  return (localStorage.getItem(LANGUE_KEY) || 'ZH') as 'ZH' | 'EN'
}

/**
 * 存语言
 */
export const locSetLangue = (val: 'ZH' | 'EN') => {
  localStorage.setItem(LANGUE_KEY, val)
  setStoreLangueFu(val)
}

// 设置仓库语言
export const setStoreLangueFu = (valTemp?: 'ZH' | 'EN') => {
  const val = valTemp ? valTemp : locGetLangue()
  store.dispatch({ type: 'layout/myLangue', payload: val })
  const myData = val === 'ZH' ? myDataTemp : myDataTemp2
  store.dispatch({ type: 'layout/myData', payload: myData })
}
